import { ThemeProvider } from 'theme-ui'
import theme from 'theme'

import { HelpCenterProvider } from 'helpCenter/providers/HelpCenter'
import { ConfirmationModalProvider } from './confirmationModal'
import { UsersProvider } from './users'
import { AuthProvider } from './auth'
import { ConfigProvider } from './config'
import { CopyProvider } from './copy'

export * from './users'
export * from './auth'
export * from './confirmationModal'
export * from './config'

export const Providers = ({ children }: { children: JSX.Element }) => {
  return (
    <AuthProvider>
      <ConfigProvider>
        {/* @ts-ignore */}
        <ThemeProvider theme={theme}>
          <UsersProvider>
            <HelpCenterProvider>
              <CopyProvider>
                <ConfirmationModalProvider>
                  {children}
                </ConfirmationModalProvider>
              </CopyProvider>
            </HelpCenterProvider>
          </UsersProvider>
        </ThemeProvider>
      </ConfigProvider>
    </AuthProvider>
  )
}
